import { feed } from "@/mocks/gossip";
import SectionHead from "./SectionHead";

const platformIcon: Record<string, string> = {
  微博: "ri-weibo-line",
  抖音: "ri-music-2-line",
  豆瓣: "ri-douban-line",
  小红书: "ri-hashtag",
};

export default function QuickFeed() {
  return (
    <section id="feed" className="mx-auto max-w-[1400px] scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
      <SectionHead
        kicker="LIVE FEED"
        title="瓜田速报"
        note="跨平台线索实时滚动，截图存证均在归档"
      />
      <div className="grid gap-x-6 gap-y-2 lg:grid-cols-2">
        {feed.map((f) => (
          <article key={f.time + f.platform} className="group flex items-center gap-4 border-b border-foreground-200/40 py-3">
            <div className="w-14 shrink-0 text-center">
              <p className="font-heading text-lg font-black text-foreground-900">{f.time}</p>
              <p className="text-[10px] text-foreground-500">今日</p>
            </div>
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
              <i className={platformIcon[f.platform] ?? "ri-flashlight-line"} />
            </div>
            <p className="flex-1 text-sm leading-relaxed text-foreground-800">{f.text}</p>
            <span className="whitespace-nowrap rounded bg-background-100 px-2 py-0.5 text-[11px] font-medium text-foreground-600">{f.tag}</span>
          </article>
        ))}
      </div>
      <a href="#download" className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700">
        <i className="ri-refresh-line" /> 加载更多实时速报（App 内滚动更新）
      </a>
    </section>
  );
}